import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, withModifiers as _withModifiers, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, createCommentVNode as _createCommentVNode, unref as _unref, createVNode as _createVNode } from "vue"

const _hoisted_1 = {
  id: "noticeContainer",
  class: "container-fluid"
}
const _hoisted_2 = {
  key: 0,
  class: "nav nav-tabs",
  id: "myTab",
  role: "tablist"
}
const _hoisted_3 = ["data-bs-target", "onClick", "aria-controls"]
const _hoisted_4 = { key: 1 }
const _hoisted_5 = {
  key: 2,
  class: "alert alert-danger"
}
const _hoisted_6 = { class: "tab-content border-start border-end border-bottom" }
const _hoisted_7 = { class: "d-flex flex-row-reverse pe-3" }

import {computed, ref, onMounted} from "vue";
import ScheduledNotices from "./Notices/ScheduledNotices.vue";
import AllNotices from "./Notices/AllNotices.vue";
import CreateEditNotice from "./Notices/CreateEditNotice.vue";
import {ScheduledItem, NoticeModel, NotificationSchedule} from "./Notices/types";
import {InformationModal, SystemAlerts} from "./Misc";
import hasPermission from "@/composable/permissionHelper";
import {Tab} from "@/types";


export default /*@__PURE__*/_defineComponent({
  __name: 'Notices',
  setup(__props) {

const tabs = computed(() => {
    let tabs = [] as Tab[];

    if (hasPermission("GenerateNotices")) {
        tabs.push({name: "Scheduled Notices", id: "scheduled"});
    }
    if (hasPermission("NoticesMainPage")) {
        tabs.push({name: "All Notices", id: "notices"});
    }

    return tabs;
});

const selectedTab = ref(tabs.value.length > 0 ? tabs.value[0].id : "");
var createEditModal = ref(false);
var selectedRow = ref({} as ScheduledItem);

var updateModalTitle = ref("");



function handleUpdateModalDismiss() {
    createEditModal.value = false;
}

function handleCreateNoticeClick() {
    selectedRow.value = {} as ScheduledItem;
    updateModalTitle.value = "Create Notice";
    createEditModal.value = true;
}

function handleEditClick(item: ScheduledItem) {
    selectedRow.value = item;
    updateModalTitle.value = "Edit Notice";
    createEditModal.value = true;
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (tabs.value.length > 1)
      ? (_openBlock(), _createElementBlock("ul", _hoisted_2, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(tabs.value, (tab) => {
            return (_openBlock(), _createElementBlock("li", {
              class: "nav-item",
              role: "presentation",
              key: tab.id
            }, [
              _createElementVNode("button", {
                class: _normalizeClass(["nav-link", {active: tab.id == selectedTab.value}]),
                "data-bs-toggle": "tab",
                "data-bs-target": `#${tab.id}`,
                type: "button",
                role: "tab",
                onClick: _withModifiers(($event: any) => (selectedTab.value = tab.id), ["prevent"]),
                "aria-controls": tab.id,
                "aria-selected": "true"
              }, _toDisplayString(tab.name), 11, _hoisted_3)
            ]))
          }), 128))
        ]))
      : (tabs.value.length === 1)
        ? (_openBlock(), _createElementBlock("h4", _hoisted_4, _toDisplayString(tabs.value[0].name), 1))
        : (_openBlock(), _createElementBlock("div", _hoisted_5, " Insufficient Access! ")),
    _createElementVNode("div", _hoisted_6, [
      (_unref(hasPermission)('GenerateNotices'))
        ? (_openBlock(), _createElementBlock("div", {
            key: 0,
            class: _normalizeClass(["tab-pane fade", selectedTab.value == 'scheduled' ? 'show active' : '']),
            id: "scheduled",
            role: "tabpanel",
            "aria-labelledby": "scheduled-tab",
            tabindex: "0"
          }, [
            _createVNode(CreateEditNotice, {
              title: _unref(updateModalTitle),
              "show-modal": _unref(createEditModal),
              item: _unref(selectedRow),
              onDismiss: handleUpdateModalDismiss
            }, null, 8, ["title", "show-modal", "item"]),
            _createElementVNode("div", _hoisted_7, [
              _createElementVNode("button", {
                id: "btnCreateNotice",
                class: "btn btn-blue pull-right mt-2",
                onClick: _cache[0] || (_cache[0] = _withModifiers(($event: any) => (handleCreateNoticeClick()), ["prevent"]))
              }, " Create Notice ")
            ]),
            _createVNode(ScheduledNotices, {
              onEditClick: _cache[1] || (_cache[1] = ($event: any) => (handleEditClick($event)))
            })
          ], 2))
        : _createCommentVNode("", true),
      _createElementVNode("div", {
        class: _normalizeClass(["tab-pane fade", selectedTab.value == 'notices' ? 'show active' : '']),
        id: "notices",
        role: "tabpanel",
        "aria-labelledby": "notices-tab",
        tabindex: "0"
      }, [
        _createVNode(AllNotices)
      ], 2)
    ]),
    _createVNode(_unref(SystemAlerts))
  ]))
}
}

})